"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var optionStyles = require("../MultiSelectInput/components/MultiSelectInputList/MultiSelectInputList.scss");
var styles = require("./ComboBox.scss");
var key_press_1 = require("../../../utils/key-press");
var MultiSelectInputList_1 = require("../MultiSelectInput/components/MultiSelectInputList");
var Debounce_1 = require("../../../helpers/Functions/Debounce");
var react_dom_1 = require("react-dom");
var UserAgent_1 = require("../../../helpers/Functions/UserAgent");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var upArrowIsPressed = key_press_1.KeyPress.upArrowIsPressed;
var downArrowIsPressed = key_press_1.KeyPress.downArrowIsPressed;
var escIsPressed = key_press_1.KeyPress.escIsPressed;
var tabIsPressed = key_press_1.KeyPress.tabIsPressed;
var ComboBox = /** @class */ (function (_super) {
    __extends(ComboBox, _super);
    function ComboBox(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.debouncedLog = Debounce_1.debounce(function (text) {
            _this.filterAndSetData(text, "change");
        }, 300);
        _this.onChange = function (e) {
            var events = _this.props.events;
            var currentValue = e.target.value;
            if (currentValue) {
                _this.setState({ currentText: currentValue, errorText: "", isClickBack: false });
                _this.debouncedLog(currentValue);
            }
            else {
                if (_this.state.isLoadInitialResult) {
                    _this.setState({
                        isOpen: true,
                        currentText: currentValue,
                        errorText: "",
                        isClickBack: false,
                    });
                    _this.filterAndSetData("", "focus");
                }
                else {
                    _this.setState({ isOpen: false, currentText: currentValue, errorText: "" });
                }
            }
            if (events && events.onChange) {
                events.onChange(e);
            }
        };
        _this.filterAndSetData = function (txtValue, from) {
            var filteredData = _this.props.data.choices;
            if (txtValue) {
                filteredData = _this.props.data.choices.filter(function (choice) {
                    var searchText = txtValue.toUpperCase();
                    var displayText = choice.displayText.toUpperCase();
                    return displayText.includes(searchText);
                });
                // tslint:disable-next-line:no-console
                var noSuggestionText = filteredData.length === 0 && txtValue ? true : false;
                _this.setState({ isOpen: true, showClose: true, filteredData: filteredData, noSuggestionText: noSuggestionText });
            }
            else {
                if (from === "focus") {
                    filteredData = _this.props.data.choices.filter(function (choice) {
                        var displayText = choice.displayText.toUpperCase();
                        return displayText;
                    });
                    _this.setState({
                        isOpen: true,
                        showClose: true,
                        filteredData: filteredData,
                        noSuggestionText: true,
                    });
                }
                else {
                    _this.setState({ filteredData: [], noSuggestionText: false });
                }
            }
        };
        _this.handleInputKeyDown = function (e) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (e.shiftKey && e.keyCode === 9) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            if (tabIsPressed(e) && currentText.length === 0) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            else if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
            }
            else if (_this.state.isOpen && downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var firstLi = el.querySelector("." + optionStyles.menuItem);
                if (firstLi) {
                    firstLi.focus();
                }
            }
            if (events && events.onKeyUp) {
                events.onKeyUp(e);
            }
            if (downArrowIsPressed(e) || upArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                e.preventDefault();
                if (liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                }
                return;
            }
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            var events = _this.props.events;
            if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                var elm = e.currentTarget.parentElement;
                var liElementMain = elm.querySelector("." + optionStyles.menuItem + ":focus");
                _this.setState({ currentText: liElementMain.innerHTML });
            }
            else if (downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                var firstLi = el.querySelectorAll("." + optionStyles.menuItem);
                if (liElement && liElement.nextElementSibling) {
                    liElement.nextElementSibling.focus();
                }
                else {
                    if (firstLi && firstLi.length) {
                        firstLi[0].focus();
                    }
                }
                e.preventDefault();
                if (!UserAgent_1.isIE()) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                    return;
                }
            }
            else if (upArrowIsPressed(e)) {
                var elUp = e.currentTarget.parentElement;
                var liUpElement = elUp.querySelector("." + optionStyles.menuItem + ":focus");
                var lastLi = elUp.querySelectorAll("." + optionStyles.menuItem);
                if (liUpElement && liUpElement.previousElementSibling) {
                    liUpElement.previousElementSibling.focus();
                }
                else {
                    if (lastLi && lastLi.length > 1) {
                        lastLi[lastLi.length - 1].focus();
                    }
                }
                e.preventDefault();
            }
            else if (key_press_1.KeyPress.tabIsPressed(e)) {
                if (_this.state.isOpen) {
                    _this.setState({
                        showClose: true,
                    }, function () {
                        var _a, _b;
                        (_b = (_a = _this.closeRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                    });
                    e.preventDefault();
                }
            }
            if (events && events.handleKeyDown) {
                events.handleKeyDown(e);
            }
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            _this.setState({ isOnFocus: true });
            if (events && events.onFocus) {
                events.onFocus(event);
            }
            if (_this.state.isLoadInitialResult && _this.state.currentText.length === 0) {
                _this.filterAndSetData("", "focus");
                _this.setState({ errorText: "" });
            }
            if (_this.state.isLoadInitialResult && _this.state.currentText.length > 0) {
                _this.showAllList();
            }
            if (!_this.state.isLoadInitialResult) {
                _this.setState({ showClose: true });
            }
        };
        _this.showAllList = function () {
            var _a;
            var currentTxt = _this.state.currentText;
            var filteredData = _this.props.data.choices;
            var checkRecord = _this.props.data.choices.filter(function (choice) {
                var searchText = currentTxt.toUpperCase();
                var displayText = choice.displayText.toUpperCase();
                return displayText === searchText;
            });
            // tslint:disable-next-line:no-console
            if (checkRecord.length === 0 && !((_a = _this.props.options) === null || _a === void 0 ? void 0 : _a.noFilterReq)) {
                _this.filterAndSetData(currentTxt, "change");
            }
            else {
                _this.setState({
                    isOpen: true,
                    showClose: true,
                    filteredData: filteredData,
                    noSuggestionText: false,
                    isClickBack: true,
                });
            }
        };
        _this.handleClickOutside = function (event) {
            var domNode = react_dom_1.findDOMNode(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.setState({
                    isOpen: false,
                    showClose: false,
                });
            }
        };
        _this.onBlur = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (_this.state.isLoadInitialResult && _this.state.isOpen && currentText.length > 0) {
                _this.setState({ isOnFocus: false, showClose: true });
            }
            else if (_this.state.isLoadInitialResult) {
                _this.setState({ isOnFocus: false, showClose: false });
            }
            else {
                _this.setState({ isOnFocus: false, showClose: false });
            }
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
        };
        _this.onSelect = function (choice, enter) {
            var events = _this.props.events;
            _this.setState({
                isOpen: false,
                currentText: choice.displayText ? choice.displayText : "",
                showClose: false,
            });
            if (events && events.onSelect) {
                var response = { dropdown: false, focus: false };
                response = events.onSelect(choice);
                if (response && response.dropdown) {
                    _this.setState({ isOpen: true,
                        isOnFocus: true,
                        currentText: "" });
                }
            }
        };
        _this.clearInput = function (e) {
            var _a, _b;
            e.preventDefault();
            _this.setState({ currentText: "", isOpen: false, isOnFocus: true });
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            if (_this.state.isLoadInitialResult) {
                _this.filterAndSetData("", "focus");
                _this.setState({ errorText: "" });
            }
        };
        _this.closeOnBlur = function (e) {
            _this.setState({ isOpen: false, showClose: false });
        };
        _this.onNoSuggestionSelect = function () {
            _this.setState({ isOpen: false });
        };
        _this.closeIcon = function () {
            return (React.createElement(React.Fragment, null, _this.state.currentText.length && _this.state.showClose ? (React.createElement("button", { className: styles.closePosition + " right mar-r-xxs icon-close absolute", onMouseDown: _this.clearInput, onBlur: _this.closeOnBlur, ref: _this.closeRef, "aria-label": "Clear Input field" })) : ("")));
        };
        _this.getFindIndex = function (inputText, listText) {
            if (inputText === listText && _this.state.isClickBack === true) {
                return true;
            }
            return false;
        };
        _this.closeRef = React.createRef();
        _this.inputRef = React.createRef();
        _this.state = {
            isOpen: false,
            currentData: props.data,
            currentText: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.value) ? props.data.value : "",
            currentValue: null,
            filteredData: [],
            isOnFocus: false,
            errorText: ((_b = props.options) === null || _b === void 0 ? void 0 : _b.errorText) ? props.options.errorText : "",
            showClose: false,
            alertText: "",
            isLoadInitialResult: ((_c = props.options) === null || _c === void 0 ? void 0 : _c.isLoadInitialResult) === false ? false : true,
            noFilterReq: ((_d = props.options) === null || _d === void 0 ? void 0 : _d.noFilterReq) ? props.options.noFilterReq : false,
        };
        return _this;
    }
    ComboBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (JSON.stringify(nextProps.data.choices) !== JSON.stringify(this.props.data.choices)) {
            var filtereddata = nextProps.data.choices;
            this.setState(__assign(__assign({}, this.state), { filteredData: filtereddata, noFilterReq: nextProps.options.noFilterReq }));
        }
    };
    ComboBox.prototype.componentDidMount = function () {
        document.addEventListener("click", this.handleClickOutside, true);
    };
    ComboBox.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
    };
    ComboBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId;
        var id = "input-" + testId;
        var ariaControlId = "aria-control-" + testId;
        var _b = this.state, isOpen = _b.isOpen, filteredData = _b.filteredData, currentText = _b.currentText, noSuggestionText = _b.noSuggestionText, errorText = _b.errorText;
        var dropdownCls = isOpen
            ? [
                styles.dropdown,
                "block pad-none left right absolute overflow-hidden bg-ui-white border border-medium-gray",
            ].join(" ")
            : [styles.dropdown, "absolute left right overflow-hidden hide"].join(" ");
        var choices = this.props.data.choices;
        var noDataFound = false;
        if (choices && choices.length === 0) {
            noDataFound = true;
        }
        var labelClass = errorText && errorText.length > 0 ? "error" : "";
        return (React.createElement("div", { "data-test-id": testId, className: styles.divPosition },
            React.createElement("div", { className: "inline-flex" }, data.labelText && (React.createElement(React.Fragment, null,
                React.createElement("label", { className: labelClass + " formfield-label", htmlFor: id }, data.labelText),
                React.createElement("span", { className: "hidden-spoken" }, errorText && errorText.length > 0 ? errorText : null),
                (options === null || options === void 0 ? void 0 : options.tooltip) !== undefined && options.tooltip))),
            React.createElement("div", null,
                React.createElement("div", { id: "multi-select-container" },
                    React.createElement("input", { id: id, "aria-describedby": errorText && errorText.length > 0 ? "msg_" + id : undefined, className: "textfield pad-r-lg rel", autoComplete: "off", "aria-autocomplete": "list", "aria-controls": ariaControlId, value: currentText, type: "text", placeholder: data.placeHolder, "aria-invalid": errorText && errorText.length > 0 ? true : undefined, onChange: this.onChange, onKeyDown: this.handleInputKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, tabIndex: 0, ref: this.inputRef }),
                    errorText && errorText.length > 0 && (React.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: { __html: errorText }, id: "msg_" + id, role: "alert" })),
                    React.createElement("div", { id: ariaControlId, className: dropdownCls },
                        React.createElement("div", { className: styles.showAllResult },
                            currentText.length > 0 && (React.createElement("div", { className: "hidden-spoken", "aria-live": "polite", dangerouslySetInnerHTML: {
                                    __html: filteredData.length + "\n                            suggestions shown, use your arrow keys to navigate through them and Enter to select",
                                } })),
                            React.createElement("ul", { role: "menu" },
                                noSuggestionText &&
                                    currentText &&
                                    filteredData.length === 0 ? (React.createElement("li", { className: optionStyles.menuItem +
                                        " " +
                                        " pad-t-xs " +
                                        styles.resultNotFound, "aria-label": options === null || options === void 0 ? void 0 : options.noSuggestionsText, tabIndex: -1, role: "option", onKeyDown: this.handleKeyDown },
                                    React.createElement("span", null, options === null || options === void 0 ? void 0 : options.noSuggestionsText))) : (""),
                                filteredData.map(function (choice, index) { return (React.createElement(MultiSelectInputList_1.default, { testId: _this.props.testId + " \"_Option_\" " + index + ")", key: choice.value, data: {
                                        choice: choice,
                                        isSelected: _this.getFindIndex(currentText, choice.displayText)
                                            ? true
                                            : false,
                                        textData: currentText || "",
                                    }, onSelect: noDataFound
                                        ? _this.onNoSuggestionSelect
                                        : _this.onSelect, options: {
                                        heighlightTextData: true,
                                        isCombobox: {
                                            isHoverColor: true,
                                            isHoverFocusColor: true,
                                            isAddBgColor: _this.state.isClickBack
                                                ? true
                                                : false,
                                        },
                                    }, handelKeyDown: _this.handleKeyDown })); })))),
                    this.closeIcon())),
            React.createElement("div", { "aria-live": "assertive", role: "status" },
                React.createElement("span", { className: "hidden-spoken" },
                    " ",
                    this.state.alertText))));
    };
    return ComboBox;
}(React.Component));
exports.default = ComboBox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ComboBox/ComboBox.js
// module id = 1762
// module chunks = 8